<mat-dialog-content>
    <p>
        Edit Room
    </p>
    <form focusInvalidInput class="form" #newSystemDesignForm="ngForm"
        >
        <div class="d-flex flex-wrap row mt-5">
            <div class="d-flex mb-3 col-md-6 flex-column px-3">
                <div class="d-flex">
                    <p class="design-overview-wrapper__item__title">Room Description<i style="color:red;">*</i></p>
                </div>
                <mat-form-field floatLabel="always">
                    <input matInput type="text" [(ngModel)]="dialogData.room_descr"
                        [ngModelOptions]="{standalone: false}" name="room_descr" class="example-right-align"
                        #room_descr='ngModel'>
                </mat-form-field>

            </div>
            <div class="d-flex mb-3 col-md-6 flex-column px-3">
                <p class="design-overview-wrapper__item__title">Design Airflow CFM<i style="color:red;">*</i></p>
                <mat-form-field floatLabel="always">
                    <input matInput type="number" [(ngModel)]="dialogData.dsh_heat_flow"
                        [ngModelOptions]="{standalone: false}" name="dsh_heat_flow" class="example-right-align"
                        #dsh_heat_flow='ngModel'>
                </mat-form-field>

            </div>
        </div>

    </form>

</mat-dialog-content>
<mat-dialog-actions class="py-0" align="center">
    <button mat-button color="primary" (click)="save()">Save</button>
    <button mat-button color="warn" mat-dialog-close (click)="cancel()">Cancel</button>
</mat-dialog-actions>